module.exports = __webpack_public_path__ + "static/img/wood.dfdb360.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/textures/wood.png
// module id = 445
// module chunks = 1